// Copyright (c) StrangeBee 2024

import { Space } from 'antd';
import React, { ReactElement } from 'react';
import { AnalyzerOutput, ActionOutput, ObservableOutput } from 'thehive-sdk';
import { ObservableEventList } from '@Organisms/Observable/eventList';
import { AnalyzerReport } from './AnalyzerReport';

import './AnalyzerAnalysis.scss';

interface AnalyzerAnalysisProps {
    name: AnalyzerOutput['name'];
    analysis: ActionOutput[];
    eventList: ObservableEventList;
    extend?: boolean;
    observable?: ObservableOutput;
    importObservable?: boolean;
    visibleReportId?: string;
}

export const AnalyzerAnalysis = React.memo(
    ({
        extend,
        analysis,
        observable,
        eventList,
        importObservable = true,
        visibleReportId,
    }: AnalyzerAnalysisProps): ReactElement => (
        <Space direction="vertical">
            {analysis
                .sort((a, b) => {
                    const fieldA = a._updatedAt ? a.endDate || a._createdAt : a._createdAt;
                    const fieldB = b._updatedAt ? b.endDate || b._createdAt : b._createdAt;

                    return fieldB - fieldA;
                })
                .map((analyse, i) => (
                    <AnalyzerReport
                        eventList={eventList}
                        analyse={analyse}
                        key={analyse._id}
                        extend={extend}
                        importObservable={importObservable}
                        indexFirst={i === 0}
                        observable={observable}
                        defaultVisible={analyse._id === visibleReportId}
                    />
                ))}
        </Space>
    ),
);
